// Library Methods
import { useContext } from "react";
import { useTranslation } from "react-i18next";

// Components
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import HeadsetFitCard from "../shared/HeadsetFitCard";
import SummarySection from "./SummarySection/SummarySection";

// Contexts
import { ReportSectionContext } from "src/contexts/reports/ReportSectionContext";

const DeviationAndCorrespondenceGraph = () => {
  const { t } = useTranslation();
  const { examReport } = useContext(ReportSectionContext);

  const modules = examReport?.postProcessing?.summary;
  const objectiveAlignment = modules?.ObjectiveAlignment;
  const subjectiveAngle = modules?.SubjectiveAngle;
  const cyclodeviation = modules?.Cyclodeviation;

  if (!objectiveAlignment && !subjectiveAngle && !cyclodeviation) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center" }}>
        <Typography fontSize="14px" fontWeight={600} color="#E10C0C">
          {t("No Data Available.")}
        </Typography>
      </Box>
    );
  }

  const calibration = examReport?.postProcessing?.calibration;
  const eyeModel = examReport?.postProcessing?.eyeModel;

  return (
    <Box display="flex" flexDirection="column" width="100%" gap="8px">
      {/* The headset leads. Everything under it is a statement about the patient that is only
          worth reading if the tracker was working -- and this whole section is measured
          through the tracker. */}
      <HeadsetFitCard
        residualDegrees={calibration?.residualDegrees}
        qualityFloorMet={calibration?.qualityFloorMet}
        interpupillaryDistanceMetres={eyeModel?.interpupillaryDistanceMetres}
        interpupillaryDistanceMeasured={
          eyeModel?.interpupillaryDistanceMeasured
        }
      />
      <SummarySection summary={examReport?.postProcessing?.summary} />
    </Box>
  );
};

export default DeviationAndCorrespondenceGraph;
